import { atomWithQuery } from 'jotai-tanstack-query';

import { getSymbolsApi } from '@flipster/apis/v2/market';
import { InstrumentProductType, InstrumentProductTypeEnum } from '@flipster/apis/v2/snapshot';

export type ProductType = 'perpetual' | 'spot';

export const symbolsQueryAtom = createSymbolsQueryAtom();
export const symbolsPerpQueryAtom = createSymbolsQueryAtom(InstrumentProductTypeEnum.Pswap);
export const symbolsSpotQueryAtom = createSymbolsQueryAtom(InstrumentProductTypeEnum.Spot);

function createSymbolsQueryAtom(productType?: InstrumentProductType) {
  return atomWithQuery(() => ({
    queryKey: ['getSymbolsApi', productType],
    queryFn: () => getSymbolsApi(productType && { productType }).then((res) => res.data),
  }));
}
